import React from 'react';
import ReactDOM from 'react-dom/client';
import Store from './redux/Store';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
const theme = createTheme({
  palette: {
      primary: {
          main: '#004F9E'
      },
      white: {
          main: '#fff'
      },
      secondary:{
          main: '#fe5200'
      }
  },
  tableHeaderColor:{
      isSupHeadingColor:"#DAEDFE",
      isHeadingColor:"#BFE1FF",
      isSubHeadingColor:"#f1f9ff",
      isTotalColor:"#eeeeee",
      textColor:"#444444"
  },
  components: {
      MuiButton: {
          styleOverrides: {
              outlined: {
                  borderWidth: '2px',
                  fontSize:'16px'
              },
          },
      },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={Store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        {/* <Routes>
          <Route path="/agentmanagement/" element={<App />} />
          <Route path="*" element={<App />} />
        </Routes> */}
        <App />
      </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);


